import Loadable from "../../../components/Loadable";

const DaftarBiodataAlumni = Loadable(() => import("./DaftarBiodataAlumni"));
const DetilBiodataAlumni = Loadable(() => import("./DetilBiodataAlumni"));

const AlumniIndex = {
  DetilBiodataAlumni,
  DaftarBiodataAlumni,
};

export default AlumniIndex;
